import { render, staticRenderFns } from "./UserAffiliationEditor.vue?vue&type=template&id=6977c50c&"
import script from "./UserAffiliationEditor.vue?vue&type=script&lang=ts&"
export * from "./UserAffiliationEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports